import React from "react";
import PropTypes from "prop-types";

import "./canvasSection.css";

const CanvasSection = ({ children }) => {
  return (
    <section className="canvas-section">
      <div className="container">{children}</div>
    </section>
  );
};

export default CanvasSection;

CanvasSection.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/page/canvas/canvasSection/canvasSection.js